import { useQuery } from "@tanstack/react-query";
import { UseDownloadBookMonthlyReportQueryOptions } from "./types";
import { getDownloadBookMonthlyReportService } from "./service";

export function useDownloadBookMonthlyReportQuery(
  params?: Record<string, string>,
  options?: UseDownloadBookMonthlyReportQueryOptions
) {
  return useQuery({
    queryKey: ["download_book_admin", "monthly-report", params],
    queryFn: () => getDownloadBookMonthlyReportService(params),
    ...options,
  });
}
